import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../resetParameters";

export const BemessungenMikropfaehle = Object.freeze({
  EUROCODE_7: 0,
  GERMANY: 1,
  AASHTO: 2,
  FHWA: 3,
});

const initialState = {
  value: BemessungenMikropfaehle.EUROCODE_7,
};

const bemessungenMikropfaehleSlice = createSlice({
  name: "bemessungenMikropfaehle",
  initialState,
  reducers: {
    setBemessungenMikropfaehleState(state, action) {
      state.value = Number(action.payload.value);
    },
    setBemessungenMikropfaehle(state, action) {
      state.value = Number(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reset, (state, action) => {
      return { value: state.value };
    });
  },
});

export const { setBemessungenMikropfaehleState, setBemessungenMikropfaehle } =
  bemessungenMikropfaehleSlice.actions;

export default bemessungenMikropfaehleSlice.reducer;

export const selectBemessungenMikropfaehle = (state) => state.bemessungenMikropfaehle.value;
